import { z } from 'zod';

export const signupSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8).max(200),
  businessName: z.string().min(1).max(120),
  businessType: z.enum(['restaurant', 'barbershop', 'plumber', 'general']),
  subdomain: z
    .string()
    .min(3)
    .max(40)
    .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'lowercase letters, numbers, and dashes only'),
});

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
